import { create } from "zustand";

/**
 * App-level "current project" hint (in-memory, session-scoped). Supplies the
 * project name to ProjectSidebarNav / ProjectFilterBanner before the projects
 * store loads. Deliberately NOT persisted — a shared browser must never show one
 * user's project name to the next (the cost is a brief "Untitled Project" on a
 * cold reload).
 */

export interface CurrentProjectRef {
  id: string;
  name: string;
}

interface CurrentProjectState {
  currentProject: CurrentProjectRef | null;
  setCurrentProject: (project: CurrentProjectRef) => void;
}

export const useCurrentProject = create<CurrentProjectState>((set) => ({
  currentProject: null,
  setCurrentProject: (project) => set({ currentProject: project }),
}));
